// extracted by mini-css-extract-plugin
export default {"root":"IconWeb_root__UoULP"};